import React, {Component} from 'react';
import {Form, Row, Modal, Col, ButtonGroup} from "react-bootstrap";
import {Button} from "react-bootstrap";
import Alert from "react-s-alert";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import {empty} from "ramda";
import Swal from "sweetalert2";
import Select from "../../../local_node_modules/react-select"

class UpdateEndpoint extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parametersCount: 0,
            responseCodeCount: 0,
            previousButton: 'java',
            codeName: 'java',
            changeSize: false,
            documentation: [],
            responseCodes: []
        }
        this.handleClickParameterTableButton = this.handleClickParameterTableButton.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.resize = this.resize.bind(this);
        this.getCorrectCode = this.getCorrectCode.bind(this);
        this.getEndpoint = this.getEndpoint.bind(this);
        this.handleClickResponseTableButton = this.handleClickResponseTableButton.bind(this);
    }

    onChangeText(e, group) {
        let requestData = this.state.documentation;
        if (group === 'endpoint')
            requestData[e.target.id] = e.target.value;
        if (group === 'code') {
            if (this.state.documentation.code == null)
                requestData[group] = [];
            requestData[group][e.target.name] = {language: e.target.id, context: e.target.value};
        }
        if (group === 'parameters') {
            if (!this.state.documentation.parameters)
                requestData[group] = [];
            if (requestData[group][e.target.name] == null)
                requestData[group][e.target.name] = {};
            requestData[group][e.target.name][e.target.id] = e.target.value;
        }
        if (group === 'responsecodes') {
            if (this.state.documentation.responsecodes == null)
                requestData[group] = [];
            if (requestData[group][e.target.name] == null)
                requestData[group][e.target.name] = {};
            requestData[group][e.target.name][e.target.id] = e.target.value;
        }
        if (group === 'method') {
            requestData["method"] = e.value;
        }
        this.setState({documentation: requestData});
    }

    onChangeResponseCode(e, id) {
        let documentation = this.state.documentation;
        documentation['responsecodes'][id] = this.state.responseCodes.filter((item) => item.recordId.toString() === e.target.value.toString())[0];
        this.setState({documentation: documentation});
    }

    requestForm() {
        let self = this;
        let data = this.state.documentation;
        data['parameters'] = data['parameters'].filter((item) => item !== empty);
        data['responsecodes'] = data['responsecodes'].filter((item) => item !== empty);
        data['code'] = data['code'].filter((item) => item !== empty);
        if (data !== null) {
            let params = {
                url: '/servicedocumentation/updateEndpoint',
                method: 'post',
                data: data
            };
            request(params)
                .then(function (response) {
                    Swal("Başarılı!", "Veri başarıyla güncellendi !", "success");
                    self.props.refresh(self.props.sectionRecordId);
                }).catch(function (error) {
                Swal("Hata !", error, "error");
                showAxiosError(error);
            });
        }
    }

    submitForm(event) {
        this.requestForm();
        event.preventDefault();
        this.props.onOpen("")
    }

    getEndpoint(recordId) {
        let self = this;
        let params = {
            url: "/servicedocumentation/get?id=" + recordId,
            method: "get"
        };
        request(params)
            .then(function (response) {
                self.setState({documentation: response.data});
            });
    }

    componentDidMount() {
        this.getEndpoint(this.props.endpointRecordId);
        this.getResponseCodes();
    }

    handleClickParameterTableButton(sign) {
        if (sign === '+') {
            let doc = this.state.documentation;
            doc['parameters'][this.state.documentation.parameters.length] = {};
            this.setState({documentation: doc});
        }
        if (sign === '-') {
            let doc = this.state.documentation;
            doc['parameters'].pop();
            this.setState({documentation: doc});
        }
    }

    handleClickResponseTableButton(sign) {
        if (sign === '+') {
            let doc = this.state.documentation;
            let count = this.state.documentation.responsecodes.length;
            for (var i = this.state.responseCodes.length - 1; i >= 0; i--) {
                if (!doc['responsecodes'].some(r => r.recordId === this.state.responseCodes[i].recordId))
                    doc['responsecodes'][count] = this.state.responseCodes[i];
            }
            this.setState({documentation: doc});
        }
        if (sign === '-') {
            let doc = this.state.documentation;
            doc['responsecodes'].pop();
            this.setState({documentation: doc});
        }
    }
    handleClickButton(type) {
        let self = this;
        self.setState({ codeName: type });
        document.getElementById(this.state.previousButton).style = "";
        this.setState({ previousButton: type });
        document.getElementById(type).style = "background: #358ccb; color: white;";
    }
    getResponseCodes() {
        let self = this;
        let params = {
            url: "/servicedocumentation/findAllResponseCode",
            method: "get"
        };
        request(params)
            .then(function (response) {
                self.setState({responseCodes: response.data});
            });
    }

    deleteParameter(id, rowId) {
        let self = this;
        let params = {
            url: "/servicedocumentation/deleteParameter?id=" + id,
            method: "post"
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Deleted') {
                    Alert.success('Parametre başarıyla silindi !', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    let doc = self.state.documentation;
                    delete doc['parameters'][rowId];
                    self.setState({documentation: doc});
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    deleteResponseCode(id) {
        let documentation = this.state.documentation;
        documentation['responsecodes'] = documentation['responsecodes'].filter(rc => rc.recordId !== id);
        this.setState({documentation: documentation})
    }

    resize() {
        this.setState({changeSize: !this.state.changeSize});
    }

    getCorrectCode(codes) {
        let self = this;
        let codeContext = null;
        if (self.state.documentation.code != null && self.state.documentation.code.length !== 0) {
            self.state.documentation.code.map(datas => {
                if (datas.language === codes)
                    codeContext = datas.context;
            })
        }
        return codeContext;
    }

    render() {
        const endpointForm = [
            {id: 'name', name: 'Ad'},
            {id: 'explanation', name: 'Açıklama'},
            {id: 'returnValue', name: 'Dönüş Değeri'},
            /* {id: 'documentationType', name: 'Documentation Type'},
             {id: 'sectionType', name: 'Section Type'}*/
        ]
        const codeForm = [
            {id: 'java', name: 'Java'},
            {id: 'php', name: 'Php'},
            {id: 'csharp', name: 'C#'},
            {id: 'python', name: 'Python'},
            {id: 'javascript', name: 'Javascript'}
        ]
        const options = [
            {value: "Get",label: "Get"},
            {value: "Post", label: "Post"}
        ]
        return (
            <div>
                <Modal show={true}
                       animation={true}
                       dialogClassName="modal-90w"
                       size={"xxl"}
                       aria-labelledby="example-custom-modal-styling-title"
                       backdrop="static">
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            Dokümantasyon Düzenle
                            <div className=".col-12 .col-md-8">
                                <div className=".col-6 .col-md-4" style={{top: "0"}}>
                                    <p style={{display: "inline", fontWeight: 700}}>{this.props.title || ""}</p>

                                    <button type="button"

                                            onClick={() => this.props.close('')}
                                            className="close pull-right"
                                            title="Kapat"
                                            aria-label="Kapat" onClick={() => this.props.onOpen("")}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{overflowY: "scroll", height: "800px"}}>
                        <Form onSubmit={this.submitForm}>
                            <Row>

                                {/*Endpoint verileri*/}
                                <div className="formDiv">
                                    <h2>Doküman</h2>
                                    {endpointForm.map(data =>
                                        <Form.Group className="mb-3" controlId={data.id} key={data.id}>
                                            <Form.Label>{data.name}</Form.Label>
                                            <Form.Control onChange={(e) => this.onChangeText(e, 'endpoint')} type="text"
                                                          defaultValue={this.state.documentation[data.id]}
                                                          placeholder={data.name}/>
                                        </Form.Group>
                                    )}

                                    <Form.Group>
                                        <Form.Label>
                                            Dokümantasyon Başlığı
                                        </Form.Label>

                                        <Form.Control readOnly value={this.props.docName}/>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>
                                            Dokümantasyon Bölümü Başlığı
                                        </Form.Label>
                                        <Form.Control readOnly value={this.props.sectionName}/>

                                    </Form.Group>
                                </div>
                            </Row>

                            <Row>
                                {/*Code verileri*/}
                                <div className="formDiv">
                                    <h2>Kodlar</h2>
                                    <ButtonGroup id="code-grp" className="buttonGroup " >
                                        <div className="buttonGroupBorder btn-group">
                                            <Button size="sm" className="languageButton" type="button" onClick={() => this.handleClickButton('java')} style={{ background: "#358ccb", color: "white" }} id="java">Java</Button>{' '}
                                            <Button size="sm" className="languageButton" type="button" onClick={() => this.handleClickButton('php')} id="php">php</Button>{' '}
                                            <Button size="sm" className="languageButton" type="button" onClick={() => this.handleClickButton('csharp')} id="csharp">C#</Button>{' '}
                                            <Button size="sm" className="languageButton" type="button" onClick={() => this.handleClickButton('python')} id="python">Python</Button>{' '}
                                            <Button size="sm" className="languageButton" type="button" onClick={() => this.handleClickButton('javascript')} id="javascript">JS</Button>{' '}
                                        </div>
                                    </ButtonGroup>
                                    <div className="row" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                        <div className="form-group col-md-3 create-endpoints-url-select">
                                            <Select name="method"
                                                    value={this.state.documentation.method}
                                                    clearable={false}
                                                    onChange={(e) => this.onChangeText(e, 'method')}
                                                    placeholder="Metodu seçiniz"
                                                    style={{width: "100%"}}
                                                    options={options}
                                            />
                                        </div>
                                        <div className="form-group col-md-7 create-endpoints-url-input">
                                            <input type="text" className="form-control" name="url" id="url" style={{border:"1px solid black"}}
                                                   value={this.state.documentation.url}
                                                   placeholder="Metodun Urlini giriniz..." onChange={(e) => this.onChangeText(e, 'endpoint')}/>
                                        </div>


                                    </div>

                                    {codeForm.map((data, i) =>
                                    this.state.codeName === data.id &&
                                        <Form.Group className="mb-3" controlId={data.id} key={data.id}>
                                            <Form.Label>{data.name} Kodu</Form.Label>
                                            <Form.Control className="codeTextArea" onChange={(e) => this.onChangeText(e, 'code')} name={i}
                                                          as="textarea" defaultValue={this.getCorrectCode(data.id)}
                                                          rows={3}/>
                                        </Form.Group>
                                    )}
                                </div>
                            </Row>
                            <Row>
                                <div className="formDiv">
                                    <h2>Parametreler</h2>
                                    <table className="fl-table" width='550'>
                                        <thead>
                                        <tr>
                                            <th>Ad</th>
                                            <th>Açıklama</th>
                                            <th>Tip</th>
                                            <th style={{width: "50px"}}>
                                                <Button size="sm"
                                                        onClick={() => this.handleClickParameterTableButton('+')}
                                                        type="button"
                                                        style={{background: "#62b962"}}><i
                                                    className="fas fa-plus"/></Button>
                                            </th>
                                        </tr>
                                        </thead>
                                        <thead>
                                        {this.state.documentation != null && this.state.documentation.length != 0 &&
                                        this.state.documentation.parameters.map((parameter, i) => (
                                            <tr key={i}>
                                                <td><Form.Control onChange={(e) => this.onChangeText(e, 'parameters')}
                                                                  name={i}
                                                                  type="text" id="name" placeholder="Ad"
                                                                  defaultValue={parameter.name}/></td>
                                                <td><Form.Control onChange={(e) => this.onChangeText(e, 'parameters')}
                                                                  name={i}
                                                                  type="text" id="type" placeholder="Tip"
                                                                  defaultValue={parameter.type}/></td>
                                                <td><Form.Control onChange={(e) => this.onChangeText(e, 'parameters')}
                                                                  name={i}
                                                                  type="text" id="explanation" placeholder="Açıklama"
                                                                  defaultValue={parameter.explanation}/></td>
                                                <td>{parameter.recordId != null ? <Button
                                                    onClick={() =>
                                                        window.confirm(parameter.name + " adlı parametreyi silmek istediğine emin misin?") && this.deleteParameter(parameter.recordId, i)}
                                                    size="sm" type="button" className="tableMinusButton"><i
                                                    className="fas fa-minus"/></Button> : this.state.documentation.parameters.length - 1 === i &&
                                                    <Button
                                                        onClick={() => this.handleClickParameterTableButton('-')}
                                                        size="sm" type="button" className="tableMinusButton"><i
                                                        className="fas fa-minus"/></Button>
                                                }
                                                </td>
                                            </tr>
                                        ))}
                                        </thead>
                                    </table>
                                </div>
                            </Row>
                            <Row>
                                <div className="formDiv">
                                    <h2>Hata Kodları</h2>
                                    <table className="fl-table" width='550'>
                                        <thead>
                                        <tr>
                                            <th>Kod</th>
                                            <th>Mesaj</th>
                                            <th>Açıklama</th>
                                            <th>Örnek</th>
                                            <th>
                                                {this.state.responseCodes.length !== (this.state.documentation.length !== 0 && this.state.documentation.responsecodes.length !== 0 ? this.state.documentation.responsecodes.length : 0) &&
                                                <Button
                                                    onClick={() => this.handleClickResponseTableButton('+')}
                                                    size="sm" type="button" style={{background: "#62b962"}}><i
                                                    className="fas fa-plus"/></Button>
                                                }
                                            </th>
                                        </tr>
                                        </thead>
                                        <thead>
                                        {this.state.documentation.length !== 0 &&
                                        this.state.documentation.responsecodes.map((responsecode, i) => (
                                            <tr>
                                                <td><Form.Control as="select"
                                                                  onChange={(e) => this.onChangeResponseCode(e, i)}>
                                                    {this.state.responseCodes.map((rc, j) =>
                                                        !this.state.documentation.responsecodes.some(r => (r.recordId === rc.recordId)) ? (
                                                                <option value={rc.recordId}>{rc.code}</option>) :
                                                            this.state.documentation.responsecodes[i] !== undefined && this.state.documentation.responsecodes[i].recordId === rc.recordId &&
                                                            <option value={rc.recordId} selected>{rc.code}</option>
                                                    )}
                                                </Form.Control></td>
                                                <td>
                                                    <Form.Label>{responsecode.message}</Form.Label>
                                                </td>
                                                <td>
                                                    <Form.Label>{responsecode.explanation}</Form.Label>
                                                </td>
                                                <td>
                                                    <Form.Label>{responsecode.example}</Form.Label>
                                                </td>
                                                <td> {responsecode.recordId != null ?
                                                    <Button
                                                        onClick={() =>
                                                            window.confirm("Bu hata kodunu silmek istediğine emin misiniz?") && this.deleteResponseCode(responsecode.recordId)}
                                                        size="sm" type="button"
                                                        style={{background: "red"}}><i
                                                        className="fas fa-minus"/></Button> : this.state.documentation.responsecodes.length - 1 === i &&
                                                    <Button
                                                        onClick={() => this.handleClickResponseTableButton('-')}
                                                        size="sm" type="button" className="tableMinusButton"><i
                                                        className="fas fa-minus"/></Button>
                                                }
                                                </td>
                                            </tr>
                                        ))}
                                        </thead>
                                    </table>
                                </div>
                            </Row>
                            <Row>
                                <Button variant="primary" size="lg" type="submit"
                                        style={{margin: "auto", marginTop: "20px"}}>Gönder</Button>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default UpdateEndpoint;